import React from 'react';
import AssignmentCardPage from '../pages/AssignmentCardPage';
import { User, Class } from '../types/alarm';

interface ManagerAssignmentViewProps {
  userId: string;
  classId: string;
  memberGroup?: string;
  onBack: () => void;
}

/**
 * 매니저 과제 관리 카드 뷰.
 * 코디의 과제 관리 카드 페이지(AssignmentCardPage)와 동일한 레이아웃을 사용하며,
 * 미완료 전체·루틴 과제 탭만 표시하고 클래스 멤버 전체의 과제 상태를 표시한다.
 */
export const ManagerAssignmentView: React.FC<ManagerAssignmentViewProps> = ({
  userId,
  classId,
  memberGroup = 'A',
  onBack
}) => {
  const user: User | null = { id: userId } as User;
  const currentClass: Class | null = { id: classId } as Class;

  return (
    <AssignmentCardPage
      userId={userId}
      classId={classId}
      onBack={onBack}
      user={user}
      currentClass={currentClass}
      currentMemberGroup={memberGroup}
      forManager={true}
    />
  );
};

export default ManagerAssignmentView;
